import { takeLatest, put, call } from 'redux-saga/effects';
import firebase from 'firebase/app';

import {
	GET_PHOTOS,
	SET_PHOTOS
} from '../actions/Types';

export function* photosSaga() {
	yield takeLatest(GET_PHOTOS, getPhotos);
}

function* getPhotos() {
	try {
		const photos = yield call(firebaseGet);
		// console.log('getPhotos: ', photos);
		yield put({ type: SET_PHOTOS, payload: photos });
	} catch (error) {
		console.log('getAbout res error', error);
	}
}

const firebaseGet = () => {
	const firestore = firebase.firestore();
	return firestore.collection("database").doc('base').collection('photos').orderBy('created').get().then(snap => {
		let arr = [];
		snap.forEach(doc => arr.push(doc.data()));
		// feachImages(arr);
		return arr;
	});
}

/**********************************************************************
const feachImages = (images) => {

	let opt = {
		method: 'GET',
		mode: 'no-cors',
		cache: "force-cache"
	};

	images.forEach((image, i) => {
		//fetch(image.src, opt)
		//	.then(r => r.blob())
		//	.then(myBlob => {
		//		console.log('image: ' + i, URL.createObjectURL(myBlob));
		//	})
		//	.catch(e => console.log('error: ' + i, e));

		caches.match(image.src).then(response => {
			return response || fetch(image.src, opt).then(r => {
				caches.open('photos').then(cache => {
					cache.put(image.src, r);
				});
				return r.clone();
			});
		});
	});
}
**********************************************************************/


// WEBPACK FOOTER //
// ./src/sagas/photosSaga.js